import React from 'react';

export default function Post({ title, imgSrc, time, salary, body, tags, icon }) {
  return (
    <div className="post">

      {icon ? <div className="icon"><img src="/pack/svg/091-email.svg" alt="" /></div> : <></>}

      <div className="title">
        <div className="img"><img src={"/img/"+imgSrc} alt="" /></div>

        <div className="text">
          <h3>{ title }</h3>
          <div className="p">
            <p><img src="/pack/svg/106-check.svg" alt="" />  { salary }</p>
            <p><img src="/pack/svg/105-wall-clock.svg" alt="" /> { time } ago</p>
          </div>
        </div>
      </div>

      <div className="body">
        <p>{body}</p>
      </div>

      <div className="tags">
        {tags.map(one => <p key={one} className="tag">{ one }</p>)}
      </div>
    </div>
  )
}
